module.exports = "https://static.zego.com/_next/static/images/outstanding-products-4512d280107537351cf1d28851016635.png";